import { useState } from "react";

import Skeleton from "common/components/ui/Skeleton";

import { WHITELABEL_DOMAIN } from "../../../constants";
import useAgencyDomainsMutations from "../../../datahooks/useAgencyDomainsMutations";
import useAgencySettings from "../../../datahooks/useAgencySettings";
import useAgencySettingsMutations from "../../../datahooks/useAgencySettingsMutations";
import SettingsItemContainer from "../../SettingsItemContainer";
import AddDomain from "./AddDomain";
import DomainItem from "./DomainItem";
import DomainStatusAlert from "./DomainStatusAlert";
import EditSlug from "./EditSlug";

export default function Domains() {
  const { removeAgencyDomain } = useAgencyDomainsMutations();
  const { agencySettings } = useAgencySettings();
  const { updateAgencySettings } = useAgencySettingsMutations();

  const [isEditingSlug, setIsEditingSlug] = useState(false);

  let slugComponent = <Skeleton className="w-40 h-6" />;
  if (agencySettings) {
    const { slug } = agencySettings;

    const domainName = `${slug}.${WHITELABEL_DOMAIN}`;

    slugComponent = isEditingSlug ? (
      <EditSlug slug={slug} closeEditing={() => setIsEditingSlug(false)} />
    ) : (
      <div className="flex flex-col gap-y-2">
        <DomainItem
          domainName={domainName}
          onEdit={() => {
            setIsEditingSlug(true);
          }}
        />
        <DomainStatusAlert domainName={domainName} />
      </div>
    );
  }

  return (
    <SettingsItemContainer className="flex-col gap-y-3">
      <span className="text-sm-bold">Domains</span>
      {slugComponent}
      {agencySettings?.domain ? (
        <div className="flex flex-col gap-y-2">
          <DomainItem
            domainName={agencySettings.domain}
            onDelete={() => {
              updateAgencySettings({ updates: { domain: "" } }).then(() => {
                removeAgencyDomain({ domainName: agencySettings.domain });
              });
            }}
          />
          <DomainStatusAlert domainName={agencySettings.domain} />
        </div>
      ) : (
        <AddDomain />
      )}
    </SettingsItemContainer>
  );
}
